// You can write more code here

/* START OF COMPILED CODE */

import BaseScene from "../core/scenes/BaseScene";
import BtnMapPlay from "../prefabs/BtnMapPlay";
import BtnAudio from "../core/prefabs/BtnAudio";
import UIPositionContainer from "../core/components/UIPositionContainer";
import BtnBack from "../core/prefabs/BtnBack";
/* START-USER-IMPORTS */
import assetPack from '../../../static/assets/asset-pack-map.json';
import { app } from '../core/App';
import { SceneData, SceneId, TransitionPoint } from '../rooting';
import UIButton from '../core/components/UIButton';
import { WorldName, WorldNameValues } from '../level/worlds/world';
import { GameDataHandler } from '../GameDataHandler';
import { RelicNameValues } from '../level/relics/relic';
/* END-USER-IMPORTS */

export default class MapLevelSelect extends BaseScene {

  constructor() {
    super("MapLevelSelect");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // bg_sky_jpg
    this.add.image(1950, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_1
    this.add.image(1850, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_2
    this.add.image(1750, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_3
    this.add.image(1650, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_4
    this.add.image(1550, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_5
    this.add.image(1450, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_6
    this.add.image(1350, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_7
    this.add.image(1250, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_8
    this.add.image(1150, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_9
    this.add.image(1050, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_10
    this.add.image(950, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_11
    this.add.image(850, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_12
    this.add.image(750, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_13
    this.add.image(650, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_14
    this.add.image(550, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_15
    this.add.image(450, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_16
    this.add.image(350, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_17
    this.add.image(250, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_18
    this.add.image(150, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_19
    this.add.image(50, 384, "game-all", "bg-sky.jpg");

    // tile_sea_png
    this.add.image(960, 724.5, "game-all", "tile-sea.png");

    // tile_clouds_1_png
    this.add.image(434, 430, "game-all", "tile-clouds-1.png");

    // tile_clouds_2_png
    this.add.image(1555, 317, "game-all", "tile-clouds-2.png");

    // mapContainer
    const mapContainer = this.add.container(960, 384);

    // arm_grizz_png
    const arm_grizz_png = this.add.image(-537, 193, "map", "arm-grizz.png");
    mapContainer.add(arm_grizz_png);

    // arm_grizz_png_1
    const arm_grizz_png_1 = this.add.image(544, 193, "map", "arm-grizz.png");
    arm_grizz_png_1.flipX = true;
    mapContainer.add(arm_grizz_png_1);

    // map_png
    const map_png = this.add.image(13, 18, "map", "map.png");
    mapContainer.add(map_png);

    // btnLockedJungle
    const btnLockedJungle = this.add.image(44, -25, "common", "btn-locked.png");
    mapContainer.add(btnLockedJungle);

    // btnLockedCave
    const btnLockedCave = this.add.image(326, 11, "common", "btn-locked.png");
    mapContainer.add(btnLockedCave);

    // btnPlayShipwreck
    const btnPlayShipwreck = new BtnMapPlay(this, -259, 174);
    mapContainer.add(btnPlayShipwreck);

    // btnPlayJungle
    const btnPlayJungle = new BtnMapPlay(this, 46, -25);
    btnPlayJungle.visible = false;
    mapContainer.add(btnPlayJungle);

    // btnPlayCave
    const btnPlayCave = new BtnMapPlay(this, 327, 11);
    btnPlayCave.visible = false;
    mapContainer.add(btnPlayCave);

    // holder_gems_png
    this.add.image(960, 68, "common", "holder-gems.png");

    // icon_total_gems_png
    this.add.image(852, 62, "common", "icon-total-gems.png");

    // score
    const score = this.add.bitmapText(989, 64, "arco", "0");
    score.setOrigin(0.5, 0.5);
    score.text = "0";
    score.fontSize = 52;
    score.align = 1;

    // btnAudio
    const btnAudio = new BtnAudio(this, 1851, 71.5);
    this.add.existing(btnAudio);

    // btnBack
    const btnBack = new BtnBack(this, 69, 71.5);
    this.add.existing(btnBack);

    // btnAudio (components)
    const btnAudioUIPositionContainer = new UIPositionContainer(btnAudio);
    btnAudioUIPositionContainer.offsetX = 24;
    btnAudioUIPositionContainer.offsetY = 24;
    btnAudioUIPositionContainer.PinRight = true;
    btnAudioUIPositionContainer.PinTop = true;

    // btnBack (components)
    const btnBackUIPositionContainer = new UIPositionContainer(btnBack);
    btnBackUIPositionContainer.offsetX = 24;
    btnBackUIPositionContainer.offsetY = 24;
    btnBackUIPositionContainer.PinLeft = true;
    btnBackUIPositionContainer.PinTop = true;

    this.mapContainer = mapContainer;
    this.btnLockedJungle = btnLockedJungle;
    this.btnLockedCave = btnLockedCave;
    this.btnPlayShipwreck = btnPlayShipwreck;
    this.btnPlayJungle = btnPlayJungle;
    this.btnPlayCave = btnPlayCave;
    this.score = score;
    this.btnAudio = btnAudio;
    this.btnBack = btnBack;

    this.events.emit("scene-awake");
  }

  private mapContainer!: Phaser.GameObjects.Container;
  private btnLockedJungle!: Phaser.GameObjects.Image;
  private btnLockedCave!: Phaser.GameObjects.Image;
  private btnPlayShipwreck!: BtnMapPlay;
  private btnPlayJungle!: BtnMapPlay;
  private btnPlayCave!: BtnMapPlay;
  private score!: Phaser.GameObjects.BitmapText;
  private btnAudio!: BtnAudio;
  private btnBack!: BtnBack;

  /* START-USER-CODE */
  private sceneData!: SceneData;

  private isJungleNewlyUnlocked:boolean = false;
  private isCaveNewlyUnlocked:boolean = false;

  public init(data: SceneData): void {
    this.sceneData = data;

    super.init(data);
  }

  public preload(): void {

    if (this.sceneData?.sourceTransition != TransitionPoint.PreloadEnd) {
      this.cache.json.remove('asset-pack-preload-cartoon-network');
      this.textures.remove('preloader-cartoon-network');
    }

    this.cache.json.remove('asset-pack-title');
    this.cache.json.remove('asset-pack-intro');
    this.textures.remove('title');
    this.textures.remove('intro');

    this.load.pack('asset-pack-map', assetPack as any);

    this.load.once(Phaser.Loader.Events.COMPLETE, this.postload, this);
  }

  public postload() {
    super.postload();
  }

  public create() {
    this.load.off(Phaser.Loader.Events.COMPLETE, this.postload, this);
    this.editorCreate();

    this.btnBack.on(UIButton.events.clicked, this.back, this);

    let highScore = this.registry.get(GameDataHandler.keys.HighScore);
    this.score.text = highScore;

    let unlockedWorlds = this.game.registry.get(GameDataHandler.keys.UnlockedWorlds) as WorldNameValues[];
    let isJungleUnlocked = unlockedWorlds.indexOf(WorldName.Jungle) !== -1;
    let isCaveUnlocked = unlockedWorlds.indexOf(WorldName.Cave) !== -1;
    let newWorlds = this.game.registry.get(GameDataHandler.keys.NewWorlds) as WorldNameValues[];
    this.isJungleNewlyUnlocked = newWorlds.indexOf(WorldName.Jungle) !== -1;
    this.isCaveNewlyUnlocked = newWorlds.indexOf(WorldName.Cave) !== -1;

    console.log(`Newly Unlocked ${newWorlds} `);
    this.btnPlayShipwreck.on(UIButton.events.clicked, () => {
      this.onSelect(WorldName.Shipwreck);
    });

    // If jungle unlocked.
    if ((isJungleUnlocked)&&(!this.isJungleNewlyUnlocked)) {
      this.btnLockedJungle.setVisible(false);
      this.btnPlayJungle.setVisible(true);
      this.btnPlayJungle.on(UIButton.events.clicked, () => {
        this.onSelect(WorldName.Jungle);
      });
    }

    // If cave unlocked.
    if ((isCaveUnlocked)&&(!this.isCaveNewlyUnlocked)) {
      this.btnLockedCave.setVisible(false);
      this.btnPlayCave.setVisible(true);
      this.btnPlayCave.on(UIButton.events.clicked, () => {
        this.onSelect(WorldName.Cave);
      });


    }

    let ty = this.mapContainer.y;
    this.mapContainer.y = 1500;
    this.mapContainer.scale = 1.5;

    this.add.tween({
      targets: this.mapContainer,
      y: ty,
      scaleX: 1,
      scaleY: 1,
      duration: 1000,
      delay: 650,
      ease: Phaser.Math.Easing.Cubic.Out
    });
    this.time.addEvent({ delay: 1500, callback: this.startIdles, callbackScope: this });
  }

  protected startIdles() {
    this.add.tween({
      targets: this.mapContainer,
      scaleX: 1.01,
      scaleY: 1.01,
      duration: 4000,
      delay: 1000,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });

    let unlocked :boolean = false;
    if(this.isJungleNewlyUnlocked){
      unlocked = true;

      this.btnPlayJungle.setVisible(true);
      this.btnPlayJungle.scale = 0;
      this.add.tween({
        targets: this.btnLockedJungle,
        scaleX: 1.8,
        scaleY: 1.8,
        alpha: 0,
        duration: 1000,
        ease: Phaser.Math.Easing.Cubic.Out,
      });
      this.add.tween({
        targets: this.btnPlayJungle,
        scaleX: 1,
        scaleY: 1,
        delay:600,
        duration: 600,
        ease: Phaser.Math.Easing.Bounce.Out,
      });
    }

    if(this.isCaveNewlyUnlocked){
      unlocked = true;

      this.btnPlayCave.setVisible(true);
      this.btnPlayCave.scale = 0;
      this.add.tween({
        targets: this.btnLockedCave,
        scaleX: 1.8,
        scaleY: 1.8,
        alpha: 0,
        duration: 1000,
        ease: Phaser.Math.Easing.Cubic.Out,
      });
      this.add.tween({
        targets: this.btnPlayCave,
        scaleX: 1,
        scaleY: 1,
        delay:600,
        duration: 600,
        ease: Phaser.Math.Easing.Bounce.Out,
      });
    }

    if(unlocked){
      app.audioHandler.playSound(this, 'SndWorldUnlock', 'sfx');
      this.time.addEvent({ delay: 1200, callback: this.unlockWorlds, callbackScope: this });
    }
  }

  private unlockWorlds(){

    if(this.isCaveNewlyUnlocked){
      this.btnLockedCave.setVisible(false);
      this.btnPlayCave.setVisible(true);
      this.btnPlayCave.on(UIButton.events.clicked, () => {
        this.onSelect(WorldName.Cave);
      });
    }

    if(this.isJungleNewlyUnlocked){
      this.btnLockedJungle.setVisible(false);
      this.btnPlayJungle.setVisible(true);
      this.btnPlayJungle.on(UIButton.events.clicked, () => {
        this.onSelect(WorldName.Jungle);
      });
    }

    GameDataHandler.clearNewWorlds(this);
  }

  public shutdown() {
    super.shutdown();
  }

  protected back() {
    app.gotoNextScene(this, TransitionPoint.MapBack);
  }

  protected onSelect(worldName: WorldNameValues) {
    if (!this.sceneData.runSettings) this.sceneData.runSettings = {};
    this.sceneData.runSettings.startWorldId = worldName;

    app.gotoNextScene(this, TransitionPoint.MapEnd, this.sceneData);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
